module.exports = __webpack_public_path__ + "static/resume-c8f2b878bf9b522da39abd5e1befe49b.pdf";